import { render, staticRenderFns } from "./educationInfo.vue?vue&type=template&id=081f78a6&scoped=true"
import script from "./educationInfo.vue?vue&type=script&lang=js"
export * from "./educationInfo.vue?vue&type=script&lang=js"
import style0 from "./educationInfo.vue?vue&type=style&index=0&id=081f78a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f78a6",
  null
  
)

export default component.exports